import VideoJsAdapter from "@javascripts/adapters/videojs_adapter";
import Button from "../button";
import Component from "../component";
import MobileSettingsBottomsheet from "./mobile_settings_bottomsheet";

export default class MobileSettingsButton extends Button {
  constructor(player, options = {}) {
    super(player, options);
    this._adapter = new VideoJsAdapter();
    this._adapter._instance = player;

    this.mobileSettingsBottomsheet = new MobileSettingsBottomsheet(
      player,
      this._adapter,
      Object.assign({}, options)
    );

    this.mobileSettingsBottomsheetFullscreen = new MobileSettingsBottomsheet(
      player,
      this._adapter,
      Object.assign({
        displayType: "fullscreen"
      },options)
    );


    document
      .querySelector(`#${this._adapter.id()}.video-js`)
      .appendChild(this.mobileSettingsBottomsheetFullscreen.el());
    
    let bottomContainer = document.createElement('div')
    bottomContainer.className = 'video-js video-js--nobg'
    bottomContainer.style = 'height: auto;';
    bottomContainer.appendChild(this.mobileSettingsBottomsheet.el())

    document
      .querySelector(`body`)
      .appendChild(bottomContainer);
  }

  createEl() {
    var props = {
      innerHTML: "",
      className: this.buildCSSClass(),
    };

    var el = Component.prototype.createEl.call(this, "button", props);
    this.createControlTextEl(el);
    return el;
  }

  get adapter(){
    return this._adapter;
  }

  handleClick(e) {
    e.stopPropagation();
    if (this.adapter.isFullscreen()) {
      this.mobileSettingsBottomsheetFullscreen.show();
      this.mobileSettingsBottomsheet.hide();
    } else {
      this.mobileSettingsBottomsheetFullscreen.hide();
      this.mobileSettingsBottomsheet.show();
    }
  }

  buildCSSClass() {
    return "vjs-settings-button vjs-mobile-settings-button vjs-control vjs-button";
  }
}

MobileSettingsButton.prototype.controlText_ = "Settings";
VideoJsAdapter.registerComponent(
  "VpMobileSettingsButton",
  MobileSettingsButton
);
